// import FBComments from './components/FBComments';
import QuizierComponent from './components/quizier';
import store from './store';
import ComponentMixin from './mixins';

const quizier = {};
const quizierOptions = {
    defaultLanguage: '',
    languages: [],
    blocks: [],
    settings: [],
    quizierEvent: {
        onInit: () => {},
    },
    post: false
};

quizier.install = (Vue, optionsOut) => {
    const options = Object.assign({}, quizierOptions, optionsOut);
    options.quizierEvent = Object.assign({},
        quizierOptions.quizierEvent,
        optionsOut.quizierEvent,
    );

    if (!options.languages || !options.languages.length) {
        throw new Error('languages is not set ')
    }

    if (!options.defaultLanguage) {
        throw new Error('defaultLanguage is not set..')
    }

    if (!options.post) {
        throw new Error('post not found')
    }

    Vue.component('quizier-viewer', QuizierComponent)
    Vue.component('fb-comment', () => import(/* webpackChunkName:"fb-comment" */ './components/FBComments'))
    Vue.component('vue-countdown', () => import(/* webpackChunkName:"vue-countdown" */ '@chenfengyuan/vue-countdown'))
    Vue.component('paginate', () => import(/* webpackChunkName:"post-pagination" */ 'vuejs-paginate'))

    /*
     * Register component initilaze
     * @TODO : Validate template for existing ?????
     */
    store.init('languages', options.languages)
    store.init('notifications', {})
    store.init('post_id', options.post)
    store.init('page', options.page)
    store.init('total_pages', options.total_pages)

    /*
     * İnit blocks
     */
    if (options.blocks) {
        // options.blocks =
        // let blocks = options.blocks.sort(store.compare)
        store.init('blocks', options.blocks)
        
        var blocks = [options.blocks]
        // prepare post pages data.
        if (options.post_pagination && options.total_pages > 1) {
            var blocks = [];
            var i = 0;
            options.blocks.forEach(function (block, index) {
                if (!blocks[i]) {
                    blocks[i] = []
                }
                blocks[i].push(block)
    
                if (block.pagebreak) {
                    i++;
                }
            });
        }
        store.init('pages', blocks)
    }

    /*
     * İnit preview
     */
    if (options.isPreview) {
        store.init('isPreview', options.isPreview);
    }

    /*
     * İnit blocks
     */
    if (options.settings) {
        store.init('settings', options.settings);
    }

    /*
     * Init Custom components
     */
    const _modules = Object.assign([], options.modules);
    // Register components
    const mList = _modules.map(m => {
        Vue.component(m.name, m.context);
        delete m.context;
        return m;
    });

    store.init("moduleList", mList);
    store.init("currentLanguge", options.defaultLanguage);
    Vue.prototype.$quizierEvent = options.quizierEvent;
};


export {
    quizier
};
export {
    ComponentMixin
};
